import axios from 'axios';

// API Base URL - später aus .env laden
// Trailing-Slashes entfernen, sonst entstehen doppelte Slashes ("//api/file/..."),
// die das Backend mit 404 quittiert.
const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3001').replace(/\/+$/, '');

// Axios-Instanz mit Basis-Konfiguration
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request Interceptor für Auth-Token
api.interceptors.request.use((config) => {
  // Sprache der Oberfläche (Backend-Meldungen, 2026-09-17)
  try {
    const lang = localStorage.getItem('dc-lang');
    if (lang === 'de' || lang === 'en') config.headers['X-Language'] = lang;
  } catch { /* localStorage blockiert */ }
  const token = localStorage.getItem('dc-sign');
  if (token) {
    config.headers['dc-sign'] = token;
  }
  return config;
});

// Response Interceptor für Error Handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Nur bei ABGELAUFENER Session umleiten — nicht beim Login-Versuch
      // selbst (falsches Passwort → 401) und nicht, wenn wir schon auf
      // /login sind; sonst verschluckt der Reload die Fehlermeldung.
      const url: string = error.config?.url ?? '';
      const isAuthCall = url.includes('/api/user/login') || url.includes('/api/user/create');
      const onLoginPage = window.location.pathname.startsWith('/login');
      if (!isAuthCall && !onLoginPage) {
        localStorage.removeItem('dc-sign');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

/**
 * Verständliche Fehlermeldung aus einer API-Fehler-Response extrahieren.
 * Das Backend antwortet bei Fehlern meist mit einem PLAIN STRING
 * ("Ein Benutzer mit dem Benutzernamen existiert bereits") — daneben gibt es
 * JSON-Formen ({message}/{error}). Reihenfolge: String-Body → message →
 * error → Fallback.
 */
export function apiErrorMessage(err: any, fallback: string): string {
  const data = err?.response?.data;
  if (typeof data === 'string' && data.trim().length > 0 && !data.trim().startsWith('<')) {
    return data.trim();
  }
  if (typeof data?.message === 'string' && data.message.trim()) return data.message.trim();
  if (typeof data?.error === 'string' && data.error.trim()) return data.error.trim();
  // 2026-10-02: Fehler OHNE Server-Antwort (lokal geworfen, z. B. „Datei zu groß“ aus einem
  // Service) tragen ihre Meldung in err.message – technische Axios-Texte bleiben außen vor.
  if (!err?.response && typeof err?.message === 'string') {
    const m = err.message.trim();
    if (m && !/^(network error|timeout|request failed|request aborted|ECONN|ERR_)/i.test(m)) return m;
  }
  return fallback;
}

export default api;